import { render, staticRenderFns } from "./PageEventGiftDelivered.vue?vue&type=template&id=333a2a5c&scoped=true&"
import script from "./PageEventGiftDelivered.vue?vue&type=script&lang=js&"
export * from "./PageEventGiftDelivered.vue?vue&type=script&lang=js&"
import style0 from "./PageEventGiftDelivered.vue?vue&type=style&index=0&id=333a2a5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333a2a5c",
  null
  
)

export default component.exports